/**
 * @voltxampere/web — Help category builtin commands (Sprint 22 C3)
 *
 * 3 commands: shortcut overlay launcher, About modal launcher,
 * GitHub repo link.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import type { Command } from "../types.js";
import { shortcutOverlayOpen } from "../../store/ui.js";
import { setPane } from "../../store/router.js";

const GITHUB_URL = "https://github.com/voltxampere/voltxampere";

export const HELP_COMMANDS: readonly Command[] = [
  {
    id: "help.shortcuts",
    titleKey: "command.help.shortcuts",
    descriptionKey: "command.help.shortcuts.desc",
    category: "help",
    shortcut: "?",
    execute: () => {
      shortcutOverlayOpen.value = true;
    },
  },
  {
    id: "help.about",
    titleKey: "command.help.about",
    descriptionKey: "command.help.about.desc",
    category: "help",
    execute: () => {
      // The About content lives in the AYARLAR pane's "about"
      // sub-tab; route there rather than building a parallel modal.
      setPane("settings");
    },
  },
  {
    id: "help.github",
    titleKey: "command.help.github",
    descriptionKey: "command.help.github.desc",
    category: "help",
    execute: () => {
      // External link. Test-environment guard: only call window.open
      // when the global is present and writable.
      if (typeof window !== "undefined" && typeof window.open === "function") {
        window.open(GITHUB_URL, "_blank", "noopener");
      }
    },
  },
];
